<template>
  <DetailInfo class="onboarding-container" :btnList="btnList">
    <div v-if="hasOnboardingAnswer" class="onboarding-content">
      <OnboardingQuestionnaire :onboardingAnswers="onboarding_answers" />
    </div>
    <InviteOnboardingQuestionnaire
      ref="inviteDialog"
      :jobId="jobId"
      :candidateId="candidateId"
      :applicationList="applicationList"
      @invited="handleInvited"
    />
  </DetailInfo>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import moment from 'moment'
import DetailInfo from './components/detailInfo.vue'
import OnboardingQuestionnaire from './components/onboardingQuestionnaire.vue'
import InviteOnboardingQuestionnaire from './dialog/inviteOnboardingQuestionnaire.vue'
import { AsyncTask } from '@/utils/common'

export default {
  components: {
    DetailInfo,
    OnboardingQuestionnaire,
    InviteOnboardingQuestionnaire
  },
  props: {
    candidateBaseInfo: {
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      exportPdfStatus: {
        loading: false,
        task: null,
        finished: false
      },
      onboarding_answers: null,
      onboarding_invitation_date: null
    }
  },
  computed: {
    candidateId () {
      return this.candidateBaseInfo.id
    },
    jobId () {
      return this.candidateBaseInfo.job.id
    },
    inviteDate: {
      get () {
        const date = this.onboarding_invitation_date
        return date ? moment(date).format('YYYY-MM-DD') : null
      },
      set (val) {
        this.onboarding_invitation_date = val
      }
    },
    hasInvited () {
      return Boolean(this.inviteDate)
    },
    hasOnboardingAnswer () {
      const answers = this.onboarding_answers
      return answers && answers.length > 0
    },
    btnList () {
      if (this.candidateBaseInfo.is_agency_uploaded_and_hid) {
        return []
      }
      const vm = this
      const list = [
        {
          get label () {
            if (vm.hasInvited) {
              return vm.$t(`${vm.i18nPrefix}.btn.invited`, { date: vm.inviteDate })
            }
            return vm.$t(`${vm.i18nPrefix}.btn.inviteOnboarding`)
          },
          onclick: this.onInviteOnboardingBtnClick
        }
      ]
      if (this.hasOnboardingAnswer) {
        list.push({
          label: this.$t(`${vm.i18nPrefix}.btn.exportPDF`),
          onclick: this.onExportBtnClick,
          get loading () {
            const exportPdfStatus = vm.exportPdfStatus
            return exportPdfStatus?.task && !exportPdfStatus.finished
          }
        },
        {
          label: this.$t(`${vm.i18nPrefix}.btn.editor`),
          onclick: this.onEditBtnClick
        })
      }
      _.forEach(list, item => {
        Object.defineProperty(item, 'disabled', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled
          }
        })
        Object.defineProperty(item, 'tooltip', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled && vm.$t(`${vm.i18nPrefix}.message.disabledTip`)
          }
        })
      })
      return list
    },
    applicationList () {
      return [{
        candidate: {
          id: this.candidateBaseInfo.id
        }
      }]
    }
  },
  created () {
    this.loadOnboardingQuestionInfo()
  },
  methods: {
    ...mapActions('application', ['getExportCandidateProfilePDFTaskStatus', 'exportCandidateProfilePDF', 'getApplicationOpenQuestionInfo']),
    async loadOnboardingQuestionInfo () {
      const params = {
        job_id: this.jobId,
        candidate_id: this.candidateId,
        question_type: 'onboarding',
        has_answered: 1
      }
      const resp = await this.getApplicationOpenQuestionInfo(params)
      if (resp) {
        this.onboarding_answers = resp.onboarding_answers
        this.onboarding_invitation_date = resp.onboarding_invitation_date
      }
    },
    onInviteOnboardingBtnClick () {
      if (this.hasInvited) {
        return
      }
      this.$refs.inviteDialog.openDialog()
    },
    async onExportBtnClick () {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePDF({
        application_id: this.candidateBaseInfo.application_id,
        show_base_info: false,
        profile_type: '2'
      }), (taskId) => this.getExportCandidateProfilePDFTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/application/export/profile/?task_id=${taskId}&download=1`)
        exportPdfStatus.loading = false
        exportPdfStatus.finished = false
        exportPdfStatus.task = null
      })
    },
    onEditBtnClick () {
      const jobId = this.jobId
      const candidateApplyJobId = this.candidateBaseInfo.candidate_apply_job_id
      const back = window.encodeURIComponent(this.$route.fullPath)
      const url = `/v-admin/application/job/${jobId}/edit/${candidateApplyJobId}?step=ONBOARDING_QUESTIONNAIRE&back=${back}`
      window.open(url)
    },
    handleInvited () {
      this.inviteDate = moment()
    }
  }
}
</script>
<style lang='scss' scoped>
.onboarding-container {
  .onboarding-content {
    margin: 0 220px;
  }
}
</style>
